/**
 * @file Spinner 加载指示
 * @description 旋转加载图标。
 *
 * @whenToUse 按钮旁、行内加载图标。
 * @whenNotToUse 包裹内容的加载蒙层（用 Spin）；骨架占位（用 Skeleton）。
 */

import { LoaderCircle } from 'lucide-react'
import { cn } from '@/lib/cn.ts'

export type SpinnerProps = {
  className?: string
  /** 无障碍文案 */
  label?: string
}

export function Spinner({ className, label = '加载中' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn('inline-flex text-primary', className)}
    >
      <LoaderCircle className="size-5 animate-spin" aria-hidden />
    </span>
  )
}
